(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  $$('[data-flip]').forEach(function(b){
    b.addEventListener('click',function(){
      var c=b.closest('.b-card'); var on=c.classList.toggle('show-real');
      b.textContent=on?b.getAttribute('data-off'):b.getAttribute('data-on');
    });
  });

  var root=$('[data-pdp]'); if(!root) return;
  var track=$('[data-track]',root), slides=$$('.b-slide',root);
  var view=$('[data-view]',root), viewTxt=$('[data-view-text]',root), viewImg=$('[data-view-img]',root);
  var thumbsWrap=$('[data-thumbs]',root), dotsWrap=$('[data-dots]',root);
  var legend='';

  function visible(){return slides.filter(function(s){return !s.hidden})}
  function idx(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth))}
  function go(i,smooth){track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'})}
  function sync(){
    var v=visible(), i=idx(), cur=v[i];
    if(!cur) return;
    var studio=cur.getAttribute('data-kind')==='studio';
    var other=v.filter(function(s){return s!==cur})[0];
    if(viewTxt) viewTxt.textContent=studio?view.getAttribute('data-to-slopes'):view.getAttribute('data-to-real');
    if(viewImg&&other) viewImg.src=other.getAttribute('data-thumb');
    $$('button',thumbsWrap).forEach(function(t,k){t.setAttribute('aria-current',k===i)});
    $$('i',dotsWrap).forEach(function(d,k){d.className=k===i?'on':''});
  }
  function render(){
    thumbsWrap.innerHTML='';dotsWrap.innerHTML='';
    visible().forEach(function(s,k){
      var b=document.createElement('button');b.type='button';b.setAttribute('data-kind',s.getAttribute('data-kind'));
      b.setAttribute('aria-label',s.getAttribute('data-kind')==='studio'?'Real product photo':'Photo on the slopes');
      b.innerHTML='<img alt="" src="'+s.getAttribute('data-thumb')+'">';
      b.addEventListener('click',function(){go(k)});thumbsWrap.appendChild(b);
      dotsWrap.appendChild(document.createElement('i'));
    });
  }
  function showLegend(t){
    legend=t;
    slides.forEach(function(s){s.hidden=s.getAttribute('data-legend')!==t});
    if(!visible().length) slides.forEach(function(s){s.hidden=false});
    render(); go(0,false); sync();
  }
  var raf; track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(sync)},{passive:true});
  window.addEventListener('resize',function(){go(idx(),false)});
  if(view) view.addEventListener('click',function(){var v=visible();go(idx()===0?Math.min(1,v.length-1):0)});

  var idInput=$('[data-id]',root), vname=$('[data-vname]',root);
  var sticky=$('[data-sticky]'), sImg=$('[data-simg]'), sName=$('[data-sname]');
  var legends=$$('[data-variant]',root);
  function pick(btn,scroll){
    legends.forEach(function(b){b.setAttribute('aria-pressed','false')});
    btn.setAttribute('aria-pressed','true');
    idInput.value=btn.getAttribute('data-variant');
    idInput.dispatchEvent(new Event('change',{bubbles:true}));
    var t=btn.getAttribute('data-title');
    if(vname) vname.textContent=t; if(sName) sName.textContent=t;
    if(sImg) sImg.src=btn.getAttribute('data-thumb');
    showLegend(t);
    if(scroll) root.scrollIntoView({behavior:'smooth',block:'start'});
    try{history.replaceState(null,'','?variant='+idInput.value)}catch(e){}
  }
  legends.forEach(function(b){b.addEventListener('click',function(){pick(b,false)})});
  $$('[data-choose]').forEach(function(b){
    b.addEventListener('click',function(){
      var t=legends.filter(function(x){return x.getAttribute('data-variant')===b.getAttribute('data-choose')})[0];
      if(t) pick(t,true);
    });
  });
  showLegend(vname?vname.textContent.trim():'');

  var qty=$('[data-qty]',root), total=$('strong[data-total]',root), sTotal=$('[data-stotal]');
  $$('input[name=b_pack]',root).forEach(function(r){
    r.addEventListener('change',function(){
      if(!r.checked) return; qty.value=r.value;
      var t=r.getAttribute('data-total'); if(total) total.textContent=t; if(sTotal) sTotal.textContent=t;
    });
  });

  var form=$('[data-form]',root), cta=$('[data-cta]',root), sBtn=$('[data-sbtn]');
  if(sBtn&&form&&!cta.disabled) sBtn.addEventListener('click',function(){form.requestSubmit?form.requestSubmit(cta):form.submit()});
  if(sticky&&cta){var st=function(){sticky.classList.toggle('on',cta.getBoundingClientRect().bottom<0)};window.addEventListener('scroll',st,{passive:true});st()}
})();
